export function UnauthorizedSvg() {
  return (
    <svg
      width='178'
      height='81'
      viewBox='0 0 178 81'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0.166992 59.0177V52.5317L33.161 6.84766H43.407V51.5917H52.807V59.0177H43.407V74.1517H34.947V59.0177H0.166992ZM35.323 15.7777L10.037 51.5917H35.323V15.7777Z'
        fill='#5B31AA'
      />
      <path
        d='M122.507 37.5663C122.507 53.8663 110.674 69.133 94.507 73.5997C93.407 73.8997 92.2069 73.8997 91.1069 73.5997C74.9402 69.133 63.1069 53.8663 63.1069 37.5663V22.933C63.1069 20.1996 65.1736 17.0996 67.7403 16.0663L86.3069 8.46641C90.4736 6.76641 95.1736 6.76641 99.3402 8.46641L117.907 16.0663C120.44 17.0996 122.54 20.1996 122.54 22.933L122.507 37.5663Z'
        stroke='#5B31AA'
        stroke-width='6'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M92.8073 42.1673C96.4892 42.1673 99.474 39.1826 99.474 35.5007C99.474 31.8188 96.4892 28.834 92.8073 28.834C89.1254 28.834 86.1406 31.8188 86.1406 35.5007C86.1406 39.1826 89.1254 42.1673 92.8073 42.1673Z'
        stroke='#5B31AA'
        stroke-width='6'
        stroke-miterlimit='10'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M92.8071 42.168V52.168'
        stroke='#5B31AA'
        stroke-width='6'
        stroke-miterlimit='10'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M133.841 24.051C134.28 18.2856 136.504 13.7736 140.515 10.515C144.526 7.25629 149.727 5.62695 156.119 5.62695C160.38 5.62695 164.046 6.41029 167.117 7.97696C170.25 9.48096 172.6 11.549 174.167 14.181C175.796 16.813 176.611 19.7896 176.611 23.111C176.611 26.9963 175.483 30.349 173.227 33.169C171.034 35.989 168.151 37.8063 164.579 38.621V39.091C168.652 40.0936 171.88 42.0676 174.261 45.013C176.642 47.9583 177.833 51.8123 177.833 56.575C177.833 60.147 177.018 63.3743 175.389 66.257C173.76 69.077 171.316 71.3016 168.057 72.931C164.798 74.5603 160.882 75.375 156.307 75.375C149.664 75.375 144.212 73.6516 139.951 70.205C135.69 66.6956 133.308 61.745 132.807 55.353H141.079C141.518 59.113 143.053 62.1836 145.685 64.565C148.317 66.9463 151.826 68.137 156.213 68.137C160.6 68.137 163.921 67.009 166.177 64.753C168.496 62.4343 169.655 59.4576 169.655 55.823C169.655 51.123 168.088 47.739 164.955 45.671C161.822 43.603 157.09 42.569 150.761 42.569H148.599V35.425H150.855C156.62 35.3623 160.976 34.4223 163.921 32.605C166.866 30.725 168.339 27.8423 168.339 23.957C168.339 20.6356 167.242 17.9723 165.049 15.967C162.918 13.9616 159.848 12.959 155.837 12.959C151.952 12.959 148.818 13.9616 146.437 15.967C144.056 17.9723 142.646 20.667 142.207 24.051H133.841Z'
        fill='#5B31AA'
      />
    </svg>
  );
}
